import { createContext } from '@lit/context';
import { WishlistRouter } from '../../templates/components/wishlist-app/wishlist-router.js';

export interface WishlistAppConfig {
  appUrl: string;
  favoritesEndpoint: string;
  collectionEndpoint: string;
  curatedCollectionEndpoint: string;
  looksEndpoint: string;
  favoritesEndpoints: string[];
  curatedCollectionEndpoints: string[];
  collectionEndpoints: string[];
  loginEndpointWithFavoritesReferrer: string;
  loginEndpointWithFavoritesEventLayerOpenReferrer: string;
  loginEndpointWithCollectionReferrer: string;
  loginEndpointWithCuratedCollectionReferrer: string;
  curatedCollectionApiEndpoint: string;
  curatedCollectionApiToModifyBocaEndpoint: string;
  productEndpoint: string;
  mixAndMatchEndpoint: string;
  productLineEndpoint: string;
  capsuleEndpoint: string;
  eventsEndpoint: string;
  eventsSeenEndpoint: string;
  eventsAppLayerEndpoint: string;
  cartEndpoint: string;
  isAppNativeBottomSheetEnabled: boolean;
  surveyCollectorId: string;
  surveyEnabled: boolean;
  showChristmasBear: boolean;
  isCurator: boolean;
  hasCuratedCollections: boolean;
  isDynamicFilteringEnabled: boolean;
  // === abtest-ents-t7700-favoriten-artikelkachel-redesign-v2 Product Tile Redesign v2 START ===
  productTileRedesign: boolean;
  // === abtest-ents-t7700-favoriten-artikelkachel-redesign-v2 Product Tile Redesign v2 END ===
  openUpdateLayer: boolean;
  removeFilterFromUrl: boolean;
  openLayerTestDecisionId?: string;
  vtoEnabled: boolean;
  vtoTtlMillis: number;
  brandsEnabled: boolean;
  brandsEndpoint: string;
  brandsEndpoints: string[];
  brandsApiEndpoint: string;
  brandsUrl: string;
  featureApiEndpoint: string;
  showBrandsTabIndicator: boolean;
  showVtoModelswitchIndicator: boolean;
  vtoCuratedAdDismissed: boolean;
}

export const wishlistAppConfigContext = createContext<WishlistAppConfig>('wishlistAppConfigContext');
export const wishlistRouterContext = createContext<WishlistRouter>('wishlistRouterContext');
